import { Component, ElementRef, HostBinding, HostListener, Input, Renderer2 } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { RefreshService } from 'services/data-tracking';

@Component({
	selector: 'panel',
	template: '<icon type="refresh" (click)="refreshData()"></icon><ng-content></ng-content>',
	styleUrls: ['./panel.component.scss'],
	imports: [IconComponent]
})
export class PanelComponent {

	@HostBinding('class.refreshable') get refreshable() { return this._refreshService?.refreshable; }
	@HostBinding('attr.refresh') get refreshingPanel() { return this._refreshService ? '' : null; }

	private _refreshService?: RefreshService;
	@Input() set refresh(value: RefreshService | undefined) {
		this._refreshService = value;
		this.refreshData();
	}

	public refreshData() { this._refreshService?.refresh(); }

	constructor(private readonly element: ElementRef<HTMLElement>, private readonly renderer: Renderer2) {  }

	private _width: number | null = 650;

	@Input('width') set width(value: number | string) {
		if (value == 'auto' || value == '100%') {
			this._width = null;
			return;
		}
		this._width = typeof value == 'number' ? value : parseInt(value);
	}
	@HostBinding('style.flex-basis')
	get flexBasisString() { return this._width === null ? '100%' : null; }
	@HostBinding('style.width')
	get widthString() { return this._width === null ? 'auto' : this._width + 'px'; }

	private _maxWidth?: number;
	@Input('maxWidth') set setMaxWidth(value: number | string) { this._maxWidth = typeof value == 'number' ? value : parseInt(value); }

	@HostBinding('style.maxWidth')
	get maxWidthString() { return this._maxWidth ? (this._maxWidth + 'px') : this._width === null ? 'none' : this.widthString; }

	private _minWidth?: number;
	@Input('minWidth') set setMinWidth(value: number | string) { this._minWidth = typeof value == 'number' ? value : parseInt(value); }
	@HostBinding('style.minWidth')
	get minWidthString() { return this._minWidth ? (this._minWidth + 'px') : null }


	@HostBinding('class.resizing')
	private resizing = false;
	private unregisterMouseMove?: Function;

	@HostListener('mousedown', ['$event']) mouseDown(event: MouseEvent) {
		const renderedWidth = this.element.nativeElement.offsetWidth;
		const offset = renderedWidth - event.offsetX;
		if (this.resizing || event.button !== 0 || offset < 0 || offset > 8 || this._width === null) return;

		const baseOffset = renderedWidth - event.clientX;
		// Register mousemove event dynamically to avoid slow pages due to unnecessary event listeners
		this.unregisterMouseMove = this.renderer.listen(document, 'mousemove', (event: MouseEvent) => {
			let newWidth = baseOffset + event.clientX;
			if (newWidth <= 200) newWidth = 200;
			if (this._maxWidth && newWidth > this._maxWidth) newWidth = this._maxWidth!;
			this.width = newWidth;
		});
		this.renderer.addClass(document.body, 'resizing');
		this.element.nativeElement.setPointerCapture(1);
		this.resizing = true;
	}
	
	@HostListener('document:mouseup', ['$event.button']) onMouseUp(mouseButton: number) {
		if (!this.resizing || mouseButton !== 0) return;

		if (this.unregisterMouseMove) this.unregisterMouseMove();
		this.renderer.removeClass(document.body, 'resizing');
		this.element.nativeElement.releasePointerCapture(1);
		this.resizing = false;
	}
}

@Component({
	selector: 'section', template: '<ng-content></ng-content>'
})
export class PanelSectionComponent {
}

@Component({
	selector: 'panel-row', template: '<ng-content></ng-content>'
})
export class PanelRowComponent {}
@Component({
	selector: 'text-group', template: '<ng-content></ng-content>'
})
export class TextGroupComponent { }
@Component({
	selector: 'wrapper', template: '<ng-content></ng-content>'
})
export class WrapperComponent {}
@Component({
	selector: 'spacer', template: '<ng-content></ng-content>'
})
export class SpacerComponent { }

export const Panel = [PanelComponent, PanelSectionComponent, PanelRowComponent, TextGroupComponent, WrapperComponent, SpacerComponent];
